
import { Component, Prop } from 'vue-property-decorator'

import { Mixins } from 'vue-mixin-decorator'
import MixinInterface from '@/_mixins/index'
import ProjectMixin from '@/_mixins/project'

import {
    observationIcons,
    statusColor,
    priorityColor,
    severityColor,
    dueStatusColor,
} from '@/types/observation'

import UserAvatar from '@/views/Project/Observation/components/userAvatar.vue'
import ContractorInfo from './contractorInfo.vue'
import TreeviewChip from '@/views/Project/Observation/components/treeviewChip.vue'
import Spa from '@/assets/countries/spa.vue'
import RestrictedToLabel from './labels/restrictedTo.vue'
import LocationDrawingChip from '@/views/Project/Observation/components/locationDrawingChip.vue'

@Component({
    components: {
        UserAvatar,
        TreeviewChip,
        ContractorInfo,
        Spa,
        RestrictedToLabel,
        LocationDrawingChip,
    },
    mixins: [ProjectMixin],
})
export default class Item extends Mixins<MixinInterface>(ProjectMixin) {
    @Prop({ required: true }) observation!: Record<string, any>
    @Prop({ required: true }) isHidden!: Function

    menuOn = false
    observationIcons = observationIcons
    statusColor = statusColor
    priorityColor = priorityColor
    severityColor = severityColor
    dueStatusColor = dueStatusColor

    navigateToCard() {
        this.$router.push({ name: 'observation', params: { observationId: this.observation.id } })
    }

    get projectTimeZone() {
        let timezone = this.observation.project.data
            ? this.$store.getters.project(this.observation.project.data.id).timeZone
            : 'Europe/Oslo'
        let offset = this.getOffset(timezone)
        return { timezone: timezone, offset: offset }
    }

    get deviceTimeZone() {
        let timezone = this.guessTimezone()
        let offset = this.getOffset(timezone)
        return { timezone: timezone, offset: offset }
    }

    get timeZone() {
        return this.observation.project.data
            ? this.observation.project.data.timeZone
            : this.guessTimezone()
    }

    get categories() {
        return this.$store.getters.observationCategories
    }

    get causes() {
        return this.$store.getters.observationCauses
    }

    get locations() {
        return this.$store.getters.projectLocations
    }
}
